import * as server from '../entries/pages/_page.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.ts";
export const imports = ["_app/immutable/nodes/2.BsA64IAe.js","_app/immutable/chunks/disclose-version.C-B3b31r.js","_app/immutable/chunks/runtime.CwyCtKqw.js","_app/immutable/chunks/legacy.CiTDcgnC.js","_app/immutable/chunks/lifecycle.D4WOZN2H.js","_app/immutable/chunks/props.Kilf3tQw.js","_app/immutable/chunks/Loading.BMrKlque.js","_app/immutable/chunks/render.Cf7suz1b.js","_app/immutable/chunks/slot.Cjv-8_r3.js","_app/immutable/chunks/index-client.DF3tuuDA.js","_app/immutable/chunks/entry.5WM1SLwB.js"];
export const stylesheets = ["_app/immutable/assets/2.I-YOC0Je.css","_app/immutable/assets/Loading.2QRZDmh7.css"];
export const fonts = [];
